export default async (value) => (value != null ? typeof value === 'object' : false)
